module.exports = __webpack_public_path__ + "6562326ee48874e03da5ec3e2949c93a.svg";